import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import { getGalleryDetail } from '@/services/gallery'
import { wrapper } from '@/store'

import AlbumSlug from './AlbumSlug'

const Page: NextPage = () => {
  return (
    <main className='min-h-screen bg-gray-100'>
      <AlbumSlug />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale, params }) => {
  const paramsDetail = {
    params: { slug: String(params?.slug) },
    headers: { 'Accept-Language': String(locale) },
  }

  await Promise.all([
    store.dispatch(getGalleryDetail.initiate(paramsDetail)),
    store.dispatch(getFloatingMenu.initiate({ headers: { ...paramsDetail.headers } })),
  ])

  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'album'])),
    },
  }
})

export default Page
